import { tamarackAPI, processApiResponse } from "./Tamarack";

export const GuarantorsDataAPI = {
	async getGuarantorsByAppId(applicantId, brokerId, email) {
		const path = `application/${applicantId}/guarantors`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async updateGuarantor(guarantors, brokerId, email) {
		const path = `application/${guarantors[0].application_id}/guarantors`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, guarantors);
		return processApiResponse(response, "put", path);
	},

	async postGuarantorData(guarantorData, brokerId, email) {
		const path = `/guarantor`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		// api.setHeader("broker-id", guarantorData.broker_id);
		const response = await tamarackAPI.post(path, guarantorData);
		return processApiResponse(response, "post", path);
	},

	async postGuarantorApplication(guarantorData, brokerId, email) {
		const path = `application/${guarantorData[0].application_id}/guarantors`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		// api.setHeader("broker-Id", guarantorData[0].broker_id);
		const response = await tamarackAPI.post(path, guarantorData);
		return processApiResponse(response, "post", path);
	},

	async deleteGuarantor(guarantor, brokerId, email) {
		const path = `application/${guarantor.application_id}/guarantors/${guarantor?.id}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},

	async putRequestGuarantor(guarantor) {
		const path = `guarantor`;
		// tamarackAPI.setHeader("broker-id", brokerId);
		const response = await tamarackAPI.put(path, guarantor);
		return processApiResponse(response, "put", path);
	},

	async callExperianText(guarantorId, guarantorObj) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=textReport`;
		const response = await tamarackAPI.put(path, guarantorObj);
		return processApiResponse(response, "put", path);
	},
	async callExperianXml(guarantorId, guarantorObj) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=xmlReport`;
		const response = await tamarackAPI.put(path, guarantorObj);
		return processApiResponse(response, "put", path);
	},
	async callExperianPdf(guarantorId, guarantorObj) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=pdfReport`;
		const response = await tamarackAPI.put(path, guarantorObj);
		return processApiResponse(response, "put", path);
	},
	async callClear(guarantorId) {
		const path = `guarantor/${guarantorId}/clearConsumers?action=pull`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "post", path);
	},
	async archiveExperianTextReport(guarantorId) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=archiveTextReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "get", path);
	},
	async deleteExperianTextReport(guarantorId) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=deleteTextReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "get", path);
	},
	async deleteExperianPdfReport(guarantorId) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=deletepdfReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "put", path);
	},
	async archiveExperianPdfReport(guarantorId) {
		const path = `guarantor/${guarantorId}/experianConsumers?action=archiveXMLPdfReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "put", path);
	},
	async archiveClearPdfReport(guarantorId) {
		const path = `guarantor/${guarantorId}/clearConsumers?action=archiveClearpdfReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "get", path);
	},
	async deleteClearPdfReport(guarantorId) {
		const path = `guarantor/${guarantorId}/clearConsumers?action=deleteClearpdfReport`;
		const response = await tamarackAPI.put(path);
		return processApiResponse(response, "get", path);
	},
	async updateApplicant(applicant) {
		const path = `application`;
		const response = await tamarackAPI.put(path, applicant);
		return processApiResponse(response, "put", path);
	},
};